import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;

const Item = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`;

const Number = styled.div`
  align-items: center;
  background: ${(props) => props.color};
  border-radius: 2px;
  display: flex;
  height: 25px;
  justify-content: center;
  margin-right: 10px;
  width: 25px;
`;

const Label = styled(TextLayoutComponent.Span)`
  font-size: 15px;
`;

export {
  Container,
  Item,
  Label,
  Number,
};
